<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7hIvxT/images/cover.jpg?1684514922335" alt="This image is the cover for the book The Motivated College Graduate, Motivated Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Motivated College Graduate, Motivated Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Book Six in Motivated Series by Brian E. Howard.</b><br/><br/>There are over 120 pieces of sage advice quoted throughout the book on how to effectively conduct a job search, write a powerful resume and LinkedIn profile,cover letters, and other communications.<br/><br/>The Motivated College Graduate is the most comprehensive job search book written for the recent college graduate. It discusses real life job search issues facing today's college graduate.<br/><br/> The book provides unprecedented insight and advice from some of the most credentialed and experienced career coaches and resume writers in the industry. These coaches and resume writers have specialized practices and work with recent college graduates. You will learn how to conduct an effective job search, stand out among your competition, get interviews, and job offers!<br/><br/>Go inside the minds of these coaches and resume writers. Learn how they've coached other college graduates to land fulfilling career-level positions. Understand how the resume writers think about keywords, titling, branding, accomplishments, color, design, and a plethora of other resume writing considerations as they create winning resumes.<br/><br/><b>Based on his extensive experience in the job search industry and by tapping into the collective knowledge of career coaches and resume writers who work specifically with college graduates, Brian Howard has written a comprehensive job search book that surpasses all other job search books written for the recent college graduate.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian E. Howard
      </h2>
      
      <p class="authorDescription body article">As a Certified Career Management Coach (CCMC), a Certified Professional Resume Writer (CPRW), an actively practicing executive recruiter, and President of The Howard Group, Brian Howard has helped thousands of job seekers over the course of his career. With over 23 years of real world recruiting experience, he has received various accolades and international acclaim for his recruiting ability, and is a member of an international recruiting organization’s “Hall of Fame”. Under Brian’s leadership, The Howard Group has received the prestigious Best in Class Award for Overall Client Satisfaction and has been honored with the International Office of the Year Award. As a specialist in his field of recruiting, Brian is the only executive recruiter to have achieved the Certified Self-Funding Specialist (CSFS) designation through the Health Care Administrators Association and International Foundation of Employee Benefit Plans (IFEBP). Prior to executive search, Brian practiced law specializing in ERISA and insurance defense. He received his undergraduate and law degrees from the University of Nebraska.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Boutique of Quality Books Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cdb17766